import utils from 'helpers/utils';
import logger from 'helpers/logger';
import ServiceStore from 'stores/service.store';
import constants from 'helpers/constants';
import {processUser} from 'services/client/user/user.utils';

const path = utils.servicePath(import.meta.url);

export class ClientUserService extends ServiceStore {
  constructor (app, callbacks) {
    logger.trace(`Starting module at: services/${path}`);

    super(path, app, {
      invalidateParent: true,
      invalidateParentWithPriority: true,
      overrideListPath: 'users',
      overrideEntityPath: 'users/:userId',
      watch: ['client'],
      match: (cache, entity, id) => {
        return (entity === 'client' && Boolean(cache?.data?.passes?.find((p) => +p.clientId === +id)));
      },
      process: (data, meta) => {
        // process
        if (meta?.context?.$store?.dataType !== constants.dataTypes.other) {
          if (utils.isArray(data)) {
            return data.map(processUser);
          } else {
            return processUser(data);
          }
        } else {
          return data;
        }
      }
    }, callbacks);
  }
}
